import dashboard from "./dashboard";
import campaigns from "./campaigns";
import contacts from "./contacts";
import blackList from "./black-list";
import masksList from "./masks-list";
import configurations from "./configurations";
import userList from "./user-list";
import reports from "./reports";
import adminList from "./admin-list";
import ownerList from "./owner-list";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, campaigns, reports, blackList, contacts, adminList, userList, configurations],
};

export default menuItems;
